import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simple-import-spreadsheet-wrapper',
  templateUrl: './simple-import-spreadsheet-wrapper.component.html',
  styleUrls: ['./simple-import-spreadsheet-wrapper.component.css']
})
export class SimpleImportSpreadsheetWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
